const getAppUrl = (): string => {
  if (process.env.REACT_APP_APP_URL === undefined) {
    throw new Error("No APP URL defined.");
  }
  return process.env.REACT_APP_APP_URL;
};

export default getAppUrl;
